export interface ReleaseHighlight {
    imageUrl: string;
    htmlContent: string;
}
